import tabStyles from "../../../styles/UI/viewTab.module.css";
import IconButtonComponent from "../buttons/IconButton";
import { ReactComponent as XIcon } from "../../../assets/icons/x_grey.svg";
import { ReactElement } from "react";

const ViewTab = ({
  displayedTabName,
  selected,
  onClick,
  tabTypeName,
  fade,
  onClose,
  icon,
  maxWidth,
  chip,
  selectedBgColor,
  selectedBorderColor,
}: {
  displayedTabName: string;
  selected: string;
  onClick: (displayedTabName: string) => void;
  tabTypeName: string;
  fade?: boolean;
  onClose?: () => void;
  icon?: ReactElement;
  maxWidth?: number;
  chip?: ReactElement;
  selectedBgColor?: string;
  selectedBorderColor?: string;
}) => {
  const isSelected = selected === tabTypeName;

  const style: React.CSSProperties = {
    ...(maxWidth !== undefined && { maxWidth }),
    ...(isSelected && selectedBgColor && { backgroundColor: selectedBgColor }),
    ...(isSelected && selectedBorderColor && {
      borderColor: `${selectedBorderColor} ${selectedBorderColor} transparent ${selectedBorderColor}`,
    }),
  };

  return (
    <button
      onClick={() => onClick(displayedTabName)}
      className={`${tabStyles.viewTab} ${
        isSelected ? tabStyles.viewTabSelected : tabStyles.viewTab
      } ${fade && "fade-in-tab"}`}
      style={Object.keys(style).length > 0 ? style : undefined}
      title={displayedTabName}
    >
      {icon && icon}
      <span className={tabStyles.viewTabSpan}>{displayedTabName}</span>
      {chip && chip}
      {onClose && selected === tabTypeName && (
        <IconButtonComponent
          ariaLabel={displayedTabName}
          id="close_edit"
          onClick={onClose}
          icon={<XIcon height={20} />}
          height={16}
          width={16}
        />
      )}
    </button>
  );
};
export default ViewTab;
